import { PermitResubmission } from '@/features/city-clerk/dashboard-permit-tracking'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(app)/city-clerk/$id/projects/$projectId/permit-resubmission/',
)({
  beforeLoad: ({ context }) => {
    if (context.auth.loading) return
    if (!context.auth.userInfo?.uiCapabilities?.permitResubmissionView) {
      throw redirect({ to: '/access-denied' })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <PermitResubmission />
}
